import { render, staticRenderFns } from "./LibraryFooter.vue?vue&type=template&id=676cc4de&scoped=true"
import script from "./LibraryFooter.vue?vue&type=script&lang=js"
export * from "./LibraryFooter.vue?vue&type=script&lang=js"
import style0 from "./LibraryFooter.vue?vue&type=style&index=0&id=676cc4de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676cc4de",
  null
  
)

export default component.exports